export const getStepperStyles = () => {
  return `
    .form-control {
      border: 2px solid #DBD9D4;
      border-radius: 0.8rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      padding: 0.5rem 1rem;
      height: 48px;
      line-height: 1.5;
    }

    textarea.form-control {
      height: auto;
      padding: 0.75rem 1rem;
      resize: none;
    }

    .form-control:focus {
      border-color: #0081F1;
      box-shadow: 0 0 0 0.2rem rgba(0, 129, 241, 0.25);
    }

    .form-control.is-invalid {
      border-color: #dc3545;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    .upload-area {
      border: 2px solid #DBD9D4;
      border-radius: 0.8rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      overflow: hidden;
      margin-bottom: 0;
      padding: 0;
    }

    .upload-area.is-invalid {
      border: 2px solid #dc3545;
      border-radius: 0.8rem;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    label.form-upload-label {
      display: block;
      padding: 0.75rem 1rem;
      margin: 0;
      height: 48px;
      line-height: 1.5;
      border-radius: 0.8rem;
      border: 2px solid #DBD9D4;
      background-color: #FFFFFF;
      cursor: pointer;
      transition: all 0.15s ease-in-out;
    }

    label.form-upload-label:hover {
      background-color: #F8F9FA;
    }

    label.form-upload-label.disabled {
      background-color: #E0E0E0;
      cursor: not-allowed;
    }

    .info-icon-container {
      position: relative;
      display: inline-block;
    }
    .info-tooltip {
      visibility: hidden;
      position: fixed;
      left: 120px;
      z-index: 1000;
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
      background: transparent;
      pointer-events: none;
    }
    .info-tooltip img {
      max-width: min(510px, calc(100vw - 60px)) !important;
      height: auto !important;
      display: block !important;
      filter: drop-shadow(0 4px 40px rgba(0,0,0,0.8)) !important;
      border-radius: 12px !important;
      opacity: 0;
      transform: scale(0.95);
      transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
    }
    .info-tooltip img[alt="Title help"] {
      position: fixed;
      top: 10px;
      margin: 0;
    }
    .info-tooltip img[alt="Short description help"] {
      position: fixed;
      top: 50vh;
      transform: translate3d(0, -50%, 0) scale(0.95);
      transform-origin: left center;
      will-change: transform;
    }
    .info-icon-container:hover .info-tooltip img[alt="Short description help"] {
      transform: translate3d(0, -50%, 0) scale(1);
    }
    .info-tooltip img[alt="Long description help"] {
      position: fixed;
      top: 50vh;
      transform: translate3d(0, -50%, 0) scale(0.95);
      transform-origin: left center;
      max-width: min(800px, calc((100vw - 60px) * 0.84)) !important;
      will-change: transform;
    }
    .info-icon-container:hover .info-tooltip img[alt="Long description help"] {
      transform: translate3d(0, -50%, 0) scale(1);
    }
    .info-tooltip img[alt="Thumbnails help"] {
      position: fixed;
      bottom: 50px;
    }
    .info-icon-container:hover .info-tooltip {
      visibility: visible;
      opacity: 1;
      pointer-events: none;
    }
    .info-icon-container:hover .info-tooltip img {
      opacity: 1;
      transform: scale(1);
    }
    @media screen and (max-width: 768px) {
      .info-tooltip {
        left: 32px;
        right: 32px;
        padding: 16px;
        background-color: rgba(0, 0, 0, 0.75);
        border-radius: 12px;
      }
      .info-tooltip img {
        max-width: calc(100vw - 32px) !important;
        margin: 0 !important;
        transform: none !important;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      .info-tooltip,
      .info-tooltip img {
        transition: none;
      }
    }

    .form-control.is-invalid {
      border-color: #dc3545;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    .upload-area.is-invalid {
      border: 2px solid #dc3545 !important;
      border-radius: 0.8rem !important;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
    }
  `;
};

export const infoIconStyle = {
  width: "14px",
  height: "14px",
  cursor: "help",
  margin: "4px 8px 0 0",
  filter: "opacity(0.7)",
};

export const inputContainerStyle = {
  width: "calc(100% - 22px)",
  flexGrow: 1,
};

export const formGroupStyle = {
  display: "flex",
  alignItems: "flex-start",
};

